import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { OpenMemberRegistrationAction } from './family-plan-member-registration-dialog.action';
import { IWindowService } from 'angular';
import UtilService from '../../common/services/util.service';
import { OpenStartListenAction } from '../family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.action';
import FamilyPlanService from '../famil-plan.service';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class FamilyPlanUserRegistrationDialogController implements ActionHandler {
  private dialogElement;
  public memberNewAddress: any;
  public memberEmail:any;
  public memberBirthday:string;
  public membersMasterToken:any;
  private type: FamilyPlanTypes;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService,
    private familyPlanService: FamilyPlanService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-member-registration-dialog').remodal();
    
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenMemberRegistrationAction) {
      this.memberEmail = action.email;
      this.memberBirthday = action.birthDate;
      this.memberNewAddress = action.address;
      this.membersMasterToken = action.token;
      this.type = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public memberJoinPlan() {
    this.close();
    this.familyPlanService.joinFamilyPlan(this.memberBirthday, this.memberEmail, this.memberNewAddress, this.membersMasterToken, this.type).then(result => {
      if(result){
        this.actionDispatcher.dispatch(
          new OpenStartListenAction(this.type)
        );
      } else{
        //TODO show error
      }
    });  
  }

 
  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
  }
  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member-registration-dialog/family-plan-member-registration-dialog.controller.ts